import React from 'react';
import { StyleSheet, TextInput, TextInputProps } from 'react-native';
import Colors from '../constants/Colors';

const styles = StyleSheet.create({
  default: { color: Colors.veryDarkGray },
});

/**
 * A thin wrapper around react-native `TextInput` that applies a default
 * text color, overridable by consumers
 * Short-term workaround for accessibility / theming defaults.
 * TODO: https://github.com/PlentifulApp/plentiful/issues/3625 (text color / theming)
 */
// eslint-disable-next-line import/prefer-default-export
export function AppTextInput({ style, ...rest }: TextInputProps) {
  return <TextInput style={[styles.default, style]} {...rest} />;
}
